import { Navigate, Route, Routes } from 'react-router-dom'
import { Layout } from './components/Layout'
import { Home } from './pages/Home'
import { Introduction } from './pages/getting-started/Introduction'
import { Architecture } from './pages/getting-started/Architecture'
import { QuickStart } from './pages/getting-started/QuickStart'
import { Users } from './pages/identity/Users'
import { Roles } from './pages/identity/Roles'
import { Paths } from './pages/identity/Paths'
import { ApiKeys } from './pages/identity/ApiKeys'
import { EventsOverview } from './pages/events/EventsOverview'
import { Subscriptions } from './pages/events/Subscriptions'
import { Mailboxes } from './pages/mail/Mailboxes'
import { EmailsDocs } from './pages/mail/Emails'
import { Datasets } from './pages/storage/Datasets'
import { Documents } from './pages/storage/Documents'
import { PdfTemplates } from './pages/storage/PdfTemplates'
import { BrainerOverview } from './pages/brainer/Overview'
import { Ingredients } from './pages/brainer/Ingredients'
import { Cups } from './pages/brainer/Cups'
import { Relations } from './pages/brainer/Relations'
import { Records } from './pages/brainer/Records'
import { Steps } from './pages/brainer/Steps'
import { Drinkers } from './pages/brainer/Drinkers'
import { Preparations } from './pages/brainer/Preparations'
import { Journeys } from './pages/brainer/Journeys'
import { PlatesOverview } from './pages/plates/Overview'
import { Sections } from './pages/plates/Sections'
import { ViewTypes } from './pages/plates/ViewTypes'
import { CoffeeApi } from './pages/plates/CoffeeApi'
import { InputParams } from './pages/plates/InputParams'
import { FiltersOrdering } from './pages/plates/FiltersOrdering'
import { OutputMappings } from './pages/plates/OutputMappings'
import { PreparationViews } from './pages/plates/PreparationViews'
import { OpenPlace } from './pages/plates/OpenPlace'
import { Funnels } from './pages/connectors/Funnels'
import { ObservabilityOverview } from './pages/observability/Overview'
import { Metrics } from './pages/observability/Metrics'
import { Tracing } from './pages/observability/Tracing'

export default function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/docs/introduction" element={<Introduction />} />
        <Route path="/docs/architecture" element={<Architecture />} />
        <Route path="/docs/quick-start" element={<QuickStart />} />
        <Route path="/docs/identity/users" element={<Users />} />
        <Route path="/docs/identity/roles" element={<Roles />} />
        <Route path="/docs/identity/paths" element={<Paths />} />
        <Route path="/docs/identity/api-keys" element={<ApiKeys />} />
        <Route path="/docs/events/overview" element={<EventsOverview />} />
        <Route path="/docs/events/subscriptions" element={<Subscriptions />} />
        <Route path="/docs/mail/mailboxes" element={<Mailboxes />} />
        <Route path="/docs/mail/emails" element={<EmailsDocs />} />
        <Route path="/docs/storage/datasets" element={<Datasets />} />
        <Route path="/docs/storage/documents" element={<Documents />} />
        <Route path="/docs/storage/pdf-templates" element={<PdfTemplates />} />
        <Route path="/docs/brainer/overview" element={<BrainerOverview />} />
        <Route path="/docs/brainer/ingredients" element={<Ingredients />} />
        <Route path="/docs/brainer/cups" element={<Cups />} />
        <Route path="/docs/brainer/relations" element={<Relations />} />
        <Route path="/docs/brainer/records" element={<Records />} />
        <Route path="/docs/brainer/steps" element={<Steps />} />
        <Route path="/docs/brainer/drinkers" element={<Drinkers />} />
        <Route path="/docs/brainer/preparations" element={<Preparations />} />
        <Route path="/docs/brainer/journeys" element={<Journeys />} />
        <Route path="/docs/plates/overview" element={<PlatesOverview />} />
        <Route path="/docs/plates/sections" element={<Sections />} />
        <Route path="/docs/plates/views" element={<ViewTypes />} />
        <Route path="/docs/plates/coffee-api" element={<CoffeeApi />} />
        <Route path="/docs/plates/input-params" element={<InputParams />} />
        <Route path="/docs/plates/filters" element={<FiltersOrdering />} />
        <Route path="/docs/plates/output-mappings" element={<OutputMappings />} />
        <Route path="/docs/plates/preparation-views" element={<PreparationViews />} />
        <Route path="/docs/plates/openplace" element={<OpenPlace />} />
        <Route path="/docs/connectors/funnels" element={<Funnels />} />
        <Route path="/docs/observability/overview" element={<ObservabilityOverview />} />
        <Route path="/docs/observability/metrics" element={<Metrics />} />
        <Route path="/docs/observability/tracing" element={<Tracing />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  )
}
